import { render, staticRenderFns } from "./colItem.vue?vue&type=template&id=0a4c2aa1&scoped=true&"
import script from "./colItem.vue?vue&type=script&lang=ts&"
export * from "./colItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c2aa1",
  null
  
)

export default component.exports